import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2WithListMobile } from 'components/mapV2/MapV2Modal/layout/MapV2WithListMobile';
import { MapV2WithListPc } from 'components/mapV2/MapV2Modal/layout/MapV2WithListPc';
import { MapV2WithoutListMobile } from 'components/mapV2/MapV2Modal/layout/MapV2WithoutListMobile';
import { MapV2WithoutListPc } from 'components/mapV2/MapV2Modal/layout/MapV2WithoutListPc';
import { useAnimationControls } from 'framer-motion';
import { useContext, useEffect, useMemo } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    visibleStoryIds: string[];
}

export const MapV2Modal = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxView = useContext(CtxView);
    const ctxMapV2 = useContext(CtxMapV2);
    const isWide = ctxMapV2.isWide;

    const controls = useAnimationControls();

    useEffect(() => {
        if (!ctxMapV2.features.isHeaderEnabled) {
            return;
        }
        if (ctxModal.detailModal?.detail) {
            controls.start(
                { x: isWide ? -375 : -window.innerWidth },
                { duration: 0.3, ease: 'easeInOut' }
            );
        } else {
            controls.start({ x: 0 }, { duration: 0.3, ease: 'easeInOut' });
        }
    }, [ctxModal.detailModal?.detail]);

    const details = useMemo(
        () =>
            ctxView.allDetails
                ?.filter((detail) => props.visibleStoryIds.includes(detail.storyId))
                .sort((a, b) => {
                    const orderA = ctxMapV2.routes.getRouteOrderNumberIfExists(
                        a.connectedMarkers?.[0]?.worldMapMarkerId
                    );
                    const orderB = ctxMapV2.routes.getRouteOrderNumberIfExists(
                        b.connectedMarkers?.[0]?.worldMapMarkerId
                    );

                    if (orderA && orderB) {
                        return orderA - orderB;
                    }
                }),
        [ctxView.allDetails, props.visibleStoryIds]
    );

    if (!ctxView.allDetails || !ctxView.allMarkers) {
        return null;
    }

    const marker = ctxView.allMarkers.find(
        (e) => e.worldMapMarkerId === ctxModal.detailModal?.markerId
    );

    const storiesList = ctxModal.detailListModal
        ? ctxView.allDetails.filter((e) => ctxModal.detailListModal.storyIds.includes(e.storyId))
        : details;

    if (!ctxMapV2.features.isListEnabled) {
        if (ctxMapV2.isWide) {
            return <MapV2WithoutListPc storiesList={storiesList} marker={marker} />;
        }
        return <MapV2WithoutListMobile storiesList={storiesList} marker={marker} />;
    }

    return (
        <S_MapV2Modal className={props.className}>
            {isWide && <MapV2WithListPc storiesList={storiesList} marker={marker} />}
            {!isWide && <MapV2WithListMobile storiesList={storiesList} marker={marker} />}
        </S_MapV2Modal>
    );
};

const S_MapV2Modal = styled.div``;
